import { getSingleTemplate, getRelatedTemplates } from 'templates/api';
import { createWithEqualityFn } from 'zustand/traditional';
import { SingleTemplatePageDataState } from './types';

const useSingleTemplatesDataStore = createWithEqualityFn<SingleTemplatePageDataState>(
  (set, get) => ({
    otherTemplates: null,
    singleTemplateData: null,
    isLoading: true,
    isFetchMoreLoading: false,
    isLastPage: false,
    fetchSingleTemplateData: async (id, segments) => {
      const handleFinalError = () => {
        set({ isLoading: false });
        throw new Error('Page not found');
      };

      const headers = {
        segments,
      };

      const fetchSingleTemplatePageData = async () => {
        set({ isLoading: true });
        const { templateData, otherTemplates } = await getSingleTemplate(id, headers);

        if (!templateData) throw new Error('Page not found');

        set({
          singleTemplateData: templateData,
          otherTemplates: {
            data: otherTemplates.response,
            nextPage: otherTemplates.metadata.next_page,
          },
          isLoading: false,
        });
      };

      try {
        await fetchSingleTemplatePageData();
      } catch {
        handleFinalError();
      }
    },
    fetchMore: async (segments: string[]) => {
      set({ isFetchMoreLoading: true });

      const headers = {
        segments,
      };

      const {
        singleTemplateData,
        otherTemplates: { nextPage },
      } = get();

      const relatedTemplates = await getRelatedTemplates(singleTemplateData, nextPage, headers);
      set(state => ({
        otherTemplates: {
          data: [...state.otherTemplates.data, ...relatedTemplates.response],
          nextPage: relatedTemplates.metadata.next_page,
        },
        isFetchMoreLoading: false,
        isLastPage: !nextPage,
      }));
    },
  }),
);

export default useSingleTemplatesDataStore;
